import type React from 'react';

import { PetitionCard } from '@change-corgi/design-system-legacy/components/content';

import type { SuggestedPetitionSourceLocation } from '../../../../../../shared/types';
import type { NewlyCreatedPetition } from '../../../../types';

import { useNewlyCreatedPetitionCard } from './hooks/useNewlyCreatedPetitionCard';

type Props = Readonly<{
	petition: { node: NewlyCreatedPetition };
	parentPetitionId?: string;
	gridPosition: number;
	sourceLocation: SuggestedPetitionSourceLocation;
}>;

export const NewlyCreatedPetitionCard: React.FC<Props> = ({ petition }) => {
	const {
		data: { petitionUrl, photoUrl },
	} = useNewlyCreatedPetitionCard({
		petition,
	});

	return (
		<PetitionCard
			descriptionHtml={petition.node.description}
			heading={petition.node.ask}
			imageUrl={photoUrl}
			petitionId={petition.node.id}
			petitionUrl={petitionUrl}
			showSignButton={false}
			showVictory={false}
			supporterCount={petition.node.signatureState.signatureCount.displayed}
			supporterCountLocalized={petition.node.signatureState.signatureCount.displayedLocalized}
			userName={petition.node.user.displayName}
			userAvatarSrc={petition.node.user.photo?.userSmall.url}
		/>
	);
};
